import { eventDetailsServingType as commonEventDetailsServingType } from '../common'
import { OccasionFieldsAndEventDetails, TextType } from '../types'
import { match } from 'ts-pattern'

// Text Fields

const occasionEventOtherSimple: TextType = {
  id: 'eventTypeOtherSimple',
  placeholder: 'Esempio: Funzione aziendale/Evento',
  label: 'Qual’è l’occasione?',
  inputLabel: 'Occasione',
  type: 'text',
  needs: [],
  prefill: false,
}

export const occasions = (code: string): OccasionFieldsAndEventDetails => {
  const result: OccasionFieldsAndEventDetails = {
    skip: false,
    fields: [],
    eventDetails: [],
  }
  match(code)
    .with('BREAKFAST', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('MORNING_TEA', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('LUNCH', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('AFTERNOON_TEA', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('DINNER', () => {
      result.skip = true
      result.eventDetails.push(commonEventDetailsServingType)
    })
    .with('EVENT_OTHER_SIMPLE', () => {
      result.fields.push(occasionEventOtherSimple)
      result.eventDetails.push(commonEventDetailsServingType)
    })

  return result
}
